import React from 'react';
import { connect } from 'react-redux';

import { ModalFrame, ModalFrameInner } from 'components/modal';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';
import PromptExit from 'libs/router/prompt-exit/PromptExit';

import BrandProfileEditForm from '../brand-profile-edit-form/BrandProfileEditForm';
import ProfileSummary from 'modules/misc/components/profile-summary/ProfileSummary';

import { createAgencyBrandProfile } from 'modules/agency/reducers/agencyBrandProfiles';
import { uploadImage } from 'modules/brands/reducers/brandProfile';
import { danger } from 'redux-store/reducers/common-reducer';

import { __t, applyTranslations } from 'utils/language';
import { addProtocol } from 'utils/url';
import { getMissingImagesValidationError } from 'utils/profile';

import type { BrandProfile, BrandProfileForm, Image } from 'types';

applyTranslations(require('./brand-create-profile-modal.i18n.json'));

type Props = {
  brandProfile: BrandProfile,
  agencyProfileId: number,
  onBeforeCloseModal: () => void,
  onCloseModal: () => void,
  onAfterCloseModal: () => void,
  dispatchDanger: (message: string) => Promise<any>,
  dispatchUploadNewBrandProfileImage: (brandPofile: BrandProfile, type: string, image: Image) => Promise<any>,
  dispatchCreateAgencyBrandProfile: (b: number, a: BrandProfileForm) => Promise<any>
};

type State = {
  brandProfile: BrandProfileForm,
  isModified: boolean
};
class BrandCreateProfileModal extends React.Component<Props, State> {
  state: State = {
    brandProfile: {
      name: '',
      url: '',
      pitch: '',
      contactEmail: '',
      instagramUrl: '',
      youtubeUrl: '',
      coverImage: null,
      profileImage: null
    },
    isModified: false
  };

  addProtocolToUrls(brandProfile) {
    const keys = ['url', 'instagramUrl', 'youtubeUrl'];

    keys.forEach(key => {
      brandProfile[key] = addProtocol(brandProfile[key]); // eslint-disable-line no-param-reassign
    });

    return brandProfile;
  }

  sendImage = (type, image) => {
    const { brandProfile, dispatchUploadNewBrandProfileImage } = this.props;

    return dispatchUploadNewBrandProfileImage(brandProfile, type, image)
      .then(data => this.setState(state => ({
        brandProfile: {
          ...state.brandProfile,
          [`${type}Image`]: data
        },
        isModified: true
      })));
  };

  handleChange = (name, value) => {
    this.setState(state => ({
      brandProfile: {
        ...state.brandProfile,
        [name]: value
      },
      isModified: true
    }));
  };

  isInvalidImages = () => {
    const { brandProfile } = this.state;
    const { dispatchDanger } = this.props;

    const missingImagesError = getMissingImagesValidationError(brandProfile.coverImage, 'cover') || getMissingImagesValidationError(brandProfile.profileImage, 'profile');

    if (missingImagesError) {
      dispatchDanger(missingImagesError);
      window.scrollTo(0, 0);
      return true;
    }

    return false;
  };

  handleSubmit = () => {
    if (this.isInvalidImages()) {
      return;
    }

    const { agencyProfileId, dispatchCreateAgencyBrandProfile, onAfterCloseModal, onCloseModal } = this.props;
    let { brandProfile } = this.state;

    brandProfile = this.addProtocolToUrls(brandProfile);

    dispatchCreateAgencyBrandProfile(agencyProfileId, brandProfile)
      .then(() => {
        this.setState(() => ({
          isModified: false
        }));
      })
      .then(() => onAfterCloseModal())
      .then(() => onCloseModal())
      .catch(() => {});
  };

  handleCancel = () => {
    this.props.onBeforeCloseModal();
  };

  render() {
    const { brandProfile, isModified } = this.state;

    return (
      <div className="brand-create-profile-modal">
        {
          isModified &&
            <PromptExit type="modal" />
        }
        <ModalFrame
          title={__t('brand_create_profile_modal.modal_title')}
        >
          <ModalFrameInner>
            <VerticalSpacing type="medium" />
            <ProfileSummary
              profile={brandProfile}
              sendImage={this.sendImage}
              canEdit
            />
            <BrandProfileEditForm
              mode="create"
              isAgencyBrand
              brandProfile={brandProfile}
              onChange={this.handleChange}
              onSubmit={this.handleSubmit}
              onCancel={this.handleCancel}
            />
          </ModalFrameInner>
        </ModalFrame>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatchDanger: message => dispatch(danger(message)),
  dispatchUploadNewBrandProfileImage: (brandProfile, type, image) => dispatch(uploadImage(brandProfile, type, image)),
  dispatchCreateAgencyBrandProfile: (agencyId, profileDetails) => dispatch(createAgencyBrandProfile(agencyId, profileDetails))
});

export default connect(null, mapDispatchToProps)(BrandCreateProfileModal);
